import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const DateTimeField = ({
  id,
  label,
}) => {
  const locale = useSelector((state) => state.user.locale);
  const [date, setDate] = useState(null);

  const initField = () => {
    const element = document.getElementById(id);
    setDate(element.dataset.newValue ? dayjs(element.dataset.newValue) : null);
    delete element.dataset.newValue;
  };

  // Because we are inside a <form> tag.
  const preventEnterKeySubmit = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  const handleClear = (event) => {
    event.stopPropagation();
    setDate(null);
  };

  useEffect(() => {
    const element = document.getElementById(id);
    element.addEventListener('initReminderInput', initField);
    // Prevent submit with Enter key as we are inside a <form> tag.
    element.addEventListener('keydown', preventEnterKeySubmit);
    return () => element && element.removeEventListener('initReminderInput', initField) &&
      element.removeEventListener('keydown', preventEnterKeySubmit);
  }, []);

  return (
    <div className='col-sm-6'>
      <div className='form-group datetimeField-container'>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DateTimePicker
            value={date}
            onChange={setDate}
            label={label}
            ampm={false}
            slotProps={{
              dialog: { sx: { zIndex: 3500 } },
              popper: { sx: { zIndex: 3500 } },
              textField: { id, size: 'small', fullWidth: true },
            }}
          />
        </LocalizationProvider>
        <IconButton onClick={handleClear} edge='end' size='large'>
          <CancelIcon />
        </IconButton>
        <input
          type='hidden'
          className='form-control'
          name={id}
          value={date?.isValid() ? date.toISOString() : ''}
          readOnly
        />
      </div>
    </div>
  );
};

export default DateTimeField;
